<div
  class="py-2 element--hoverable element"
  [class.element--timeline]="timeline"
  [class.element--readonly]="readonly"
  [class.element--success]="isDelivered"
  [class.element--last]="index === lastIndex"
  *ngIf="order"
>
  <app-row [align]="detailed ? 'center' : 'flex-start'" class="no-gutters pos-relative">
    <app-col>
      <app-row gutter="x-xs">
        <app-col cols="auto">
          <div class="element__action">
            <div
              class="icon icon--small justify-center align-center radius-50 brd"
              [ngClass]="{'brd-200 text-400 bg-white': !isDelivered, 'brd-success text-white bg-success': isDelivered}"
              *ngIf="timeline"
            >
              <span class="small">{{index}}</span>
            </div>
            <button
              mat-icon-button
              class="p-0 bg-accent-lighter btn--xsmall mw-auto"
              color="accent"
              *ngIf="!readonly && timeline"
              (click)="selectOrder()"
            >
              <app-icon [name]="actionIcon"></app-icon>
            </button>
            <button
              mat-button
              class="p-1 bg-accent-lighter btn--xsmall mw-auto"
              color="accent"
              *ngIf="!readonly && !timeline"
              (click)="selectOrder()"
            >
              <app-icon [name]="actionIcon" size="xs"></app-icon>
            </button>
          </div>
          <ng-content select="[action-suffix]"></ng-content>
        </app-col>

        <app-col>
          <div class="flex align-center">
            <span class="text-dark weight-bold h6 my-auto">{{order.reference}}</span>
            <app-rect-tag *ngIf="showOrderType && OrderTypeShortcuts[order.orderType]" [color]="ColorPalette.Default" class="ml-1" size="xs">
              {{('sharedFeatures.OrderType.' + OrderTypeShortcuts[order.orderType]) | translate}}
            </app-rect-tag>

            <app-icon *ngIf="order.rush" class="ml-1" name="clock"></app-icon>
          </div>
          <div class="text-400 small">
            {{order.dropOffLocationTitle}}
            <span class="ml-1" *ngIf="detailed">• {{order.createdAt | date}}</span>
          </div>
          <div class="flex align-center">
            <div class="text-accent small">
              <app-icon class="align-middle" size="xs" name="temperature"></app-icon>
              {{DefinitionOrderTemperatureControl[order?.temperatureControl]}}
            </div>
            <a
              target="_blank"
              class="ml-1"
              [href]="order?.deliveryNoteUrl"
              [matTooltip]="'shared.accordion.Download' | translate"
              [matTooltipPosition]="'above'"
              *ngIf="order?.deliveryNoteUrl && detailed"
            >
              <app-rect-tag theme="dashed" color="success" size="xs">
                {{ 'shared.accordion.ProofOfDelivery' | translate }}
                <app-icon name="bold-download-square" size="xs" class="ml-1"></app-icon>
              </app-rect-tag>
            </a>
          </div>
        </app-col>
      </app-row>
      <!--    ref: | pallets: {{order.actualNoOfPallets}} | items: {{order.actualNoOfItems}} | created: {{order.createdAt|date}}-->
    </app-col>
    <app-col cols="auto" (click)="orderType === 'detailed' ? handleExpandPallets() : null" [class.cursor-pointer]="orderType === 'detailed'">
      <div class="small d-inline-block text-400" *ngIf="detailed">
        <!--        <span class="brd-r brd-200 pr-1">{{'sharedFeatures.CreatedAt' | translate}}: {{order.createdAt | date}}</span>-->
        <app-rect-tag *ngIf="order?.sealNumber" size="xs" theme="dashed">
          {{'shared.accordion.SealNo' | translate}}: {{order.sealNumber}}
        </app-rect-tag>
        <span class="px-1 brd-r brd-200">{{'sharedFeatures.Orders.Pallets' | translate}} {{totalCount}}</span>
        <span class="px-1">{{'sharedFeatures.Orders.ItemsWithCount' | translate:({count: totalItemsCount})}}</span>
      </div>
      <app-icon
        *ngIf="orderType === 'undetailed'"
        [popoverTrigger]="lineItemsPopover"
        [closeOnClickOutside]="true"
        [position]="popoverPosition"
        class="align-middle text-primary-light cursor-pointer"
        name="exclamation-mark"
      ></app-icon>

      <app-icon
        *ngIf="orderType === 'detailed'"
        [type]="IconType.MaterialDesign"
        [name]="palletsExpanded ? 'arrow_drop_up' : 'arrow_drop_down'"
        class="align-middle text-primary-light cursor-pointer"
      ></app-icon>

      <div class="small d-inline-block text-400" *ngIf="!detailed">{{totalItemsCount}}</div>
    </app-col>

    <ng-container *ngIf="!readonly && orderType === 'undetailed'">
      <!-- <ng-container *ngTemplateOutlet="quantityControlsTemplate"></ng-container> -->
    </ng-container>

    <ng-container *ngIf="orderType === 'detailed'">
      <ng-container *ngTemplateOutlet="palletsExpandableTemplate"></ng-container>
    </ng-container>
  </app-row>

  <ng-template #lineItemsPopover>
    <app-order-list-line-items [orderId]="order.id"></app-order-list-line-items>
  </ng-template>
</div>

<ng-template #quantityControlsTemplate>
  <div class="flex align-center pl-6">
    <span class="d-block small weight-semibold ml-2">{{'sharedFeatures.Orders.Pallets' | translate}}:</span>
    <div class="brd brd-200 radius-1 p-1 flex align-center mx-1 bg-white">
      <button mat-button class="p-1 bg-primary-lighter btn--xsmall" color="primary" [disabled]="selectedQuantity < 2" (click)="modifyQuantity(-1)">
        <app-icon name="bold-minus" size="xs"></app-icon>
      </button>

      <span class="text-center small d-inline-block" style="min-width: 1.5rem">{{selectedQuantity || 0}}</span>

      <button
        mat-button
        class="p-1 bg-primary-lighter btn--xsmall"
        color="primary"
        [disabled]="selectedQuantity >= availableQuantity"
        (click)="modifyQuantity(1)"
      >
        <app-icon name="add-square" size="xs"></app-icon>
      </button>
    </div>
    <div class="small">
      <span class="px-1">/</span>
      {{availableQuantity}}
    </div>
  </div>
</ng-template>

<ng-template #palletsExpandableTemplate>
  <app-expandable-panel
    class="d-block staged-card__pallet-contaner"
    [class.mt-3]="palletsExpanded"
    [expanded]="palletsExpanded"
    (opened)="expandPallets.emit()"
    (closed)="palletsExpanded = false"
  >
    <!--    <div class="weight-semibold text-500" toggle>{{totalCount}} {{'sharedFeatures.Orders.Pallets' | translate}}</div>-->
    <div class="pr-2">
      <app-row class="mb-2" gutter="x-xs">
        <app-col cols="auto">
          <span class="pl-6"></span>
        </app-col>
        <app-col class="brd-b brd-200 pb-2">{{'sharedFeatures.Orders.Pallets' | translate}}</app-col>
        <app-col cols="auto" class="brd-b brd-200 pb-2">{{'sharedFeatures.Orders.Items' | translate}}</app-col>
      </app-row>
      <app-row *ngFor="let pallet of pallets ;let i = index" class="mb-2" gutter="x-xs">
        <app-col cols="auto">
          <span class="pl-6"></span>
        </app-col>
        <app-col cols="auto" *ngIf="!readonly || timeline" class="brd-b brd-200 pb-2">
          <div class="element__action">
            <div class="icon icon--small justify-center align-center brd brd-200 text-400 radius-50 bg-white" *ngIf="timeline">
              <span class="small">{{i + 1}}</span>
            </div>
            <button
              mat-icon-button
              class="p-0 bg-accent-lighter btn--xsmall w-100"
              color="accent"
              *ngIf="!readonly && timeline"
              (click)="removePallet.emit({order, index: i, pallet})"
            >
              <app-icon [name]="actionIcon"></app-icon>
            </button>

            <button
              mat-button
              class="p-1 bg-primary-lighter btn--xsmall mw-auto text-primary-200"
              *ngIf="!readonly && !timeline"
              (click)="removePallet.emit({order, index: i, pallet})"
            >
              <app-icon [name]="actionIcon" size="xs"></app-icon>
            </button>
          </div>
        </app-col>
        <app-col class="brd-b brd-200 pb-2">{{pallet.reference}}</app-col>

        <app-col cols="auto" class="brd-b brd-200 pb-2">
          <span class="weight-semibold small">{{pallet.noOfItems}}</span>
        </app-col>

        <app-col cols="auto" class="brd-b brd-200 pb-2">
          <app-icon
            [popoverTrigger]="popoverPallet"
            [closeOnClickOutside]="true"
            [position]="popoverPosition"
            (click)="selectedPalletForPopover = pallet"
            class="icon icon--small align-middle text-primary-light"
            name="exclamation-mark"
          ></app-icon>
        </app-col>
      </app-row>
    </div>
  </app-expandable-panel>
</ng-template>

<ng-template #popoverPallet>
  <app-order-items-card [selectedPallet]="selectedPalletForPopover"></app-order-items-card>
</ng-template>
